export default {
  placeholder: 'Wartungsarbeiten auswählen',
  unit: 'Teile',
};
